import React, { cloneElement } from 'react';
import { TopToolbar, sanitizeListRestProps } from 'react-admin';

const ListActions = ({
  currentSort,
  className,
  resource,
  filters,
  displayedFilters,
  exporter,
  filterValues,
  permanentFilter,
  hasCreate,
  basePath,
  selectedIds,
  onUnselectItems,
  showFilter,
  maxResults,
  total,
  enabledCreate,
  handleImportarCsv = () => {},
  handleTabelaNcm = () => {},
  ...rest
}) => (
  <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
    {filters &&
      cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button',
      })}
    {/*     <Button onClick={handleTabelaNcm} label="Importar NCM JSON">
      <PublishIcon />
    </Button> */}
  </TopToolbar>
);

export default ListActions;
